/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactElement, useEffect, useState, ReactNode } from 'react'
import { RichTextEditor } from '@mantine/rte'
import parse from 'html-react-parser'
import { deepFind } from 'react-children-utilities'
import { renderToString } from 'react-dom/server'

import {
  StyledTextImageAdmin,
  StyledTwoText,
  StyledText,
} from './styled-components'
import Icon from '../../../icon'
import Button from '../../../button'
import { useAddTextAdminContext } from '../../../../contexts/add-text-admin'
import { SectionType } from '../../../../types/admin'

interface TwoTextAdminProps {
  id: number
  value: SectionType['value']
  onDeleteClick?: () => void
}

function TwoTextAdmin({
  value,
  id,
  onDeleteClick,
}: TwoTextAdminProps): ReactElement {
  const { addTextAdmin, setAddTextAdmin } = useAddTextAdminContext()

  const defaultValue = (): string[] => {
    if (value) {
      const findDiv = deepFind(
        parse(value),
        (child: ReactNode) => (child as ReactElement).type === 'div'
      )

      const textEdit1 = (findDiv as ReactElement)?.props.children[0]
      const textEdit2 = (findDiv as ReactElement)?.props.children[1]
      return [renderToString(textEdit1), renderToString(textEdit2)]
    }
    return ['', '']
  }

  const [text1, setText1] = useState<string>(defaultValue()[0])
  const [text2, setText2] = useState<string>(defaultValue()[1])

  useEffect(() => {
    if (text1 && text2) {
      const html = `<div class="two-text"><div class="text1">${text1}</div><div class="text2">${text2}</div></div>`
      const oldSections = [...addTextAdmin]

      const findIndexSection = oldSections.findIndex((e) => e.id === id)
      oldSections[findIndexSection].value = html
      setAddTextAdmin(oldSections)
    }
  }, [text1, text2])

  return (
    <StyledTextImageAdmin>
      <StyledTwoText>
        <StyledText>
          <RichTextEditor dir="rtl" value={text2} onChange={setText2} />
        </StyledText>
        <StyledText>
          <RichTextEditor dir="rtl" value={text1} onChange={setText1} />
        </StyledText>
      </StyledTwoText>
      <Button onClick={onDeleteClick} color="white">
        <Icon width={20} height={20} name="fluent:delete-28-regular" />
      </Button>
    </StyledTextImageAdmin>
  )
}

export default TwoTextAdmin
